import React from "react";
import { useAuth } from "../context/AuthProvider";
import AdminDashboard from "./admin/AdminDashboard";
import TutorDashboard from "./tutor/TutorDashboard";
import StudentDashboard from "./student/StudentDashboard";

export default function Dashboard() {
  const { user } = useAuth();

  if (!user)
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100 bg-white dark:bg-gray-900">
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3 text-muted">Loading dashboard...</p>
        </div>
      </div>
    );

  const DashboardWrapper = ({ children }) => (
    <div className="bg-white dark:bg-gray-900 text-gray-900 dark:text-white min-h-screen">
      {children}
    </div>
  );

  switch (user.role) {
    case "admin":
      return (
        <DashboardWrapper>
          <AdminDashboard />
        </DashboardWrapper>
      );
    case "tutor":
      // return <TutorDashboard />;
      return (
        <DashboardWrapper>
          <TutorDashboard />
        </DashboardWrapper>
      );
    case "student":
      return (
        <DashboardWrapper>
          <StudentDashboard />
        </DashboardWrapper>
      );
    default:
      return (
        <DashboardWrapper>
          <div className="d-flex justify-content-center align-items-center min-vh-100">
            <div className="text-center">
              <h3 className="text-danger">Unauthorized Access</h3>
              <p className="text-muted">
                You don't have permission to access this dashboard.
              </p>
            </div>
          </div>
        </DashboardWrapper>
      );
  }
}
